import { Button, Center, Image, Paper, Stack, Text, Title } from '@mantine/core';
import { Send } from 'lucide-react';
import logo from '@/assets/logo.png';
import { clearToken, loginUrl } from '@/auth/session';

export function LoginScreen() {
    return (
        <Center mih="100dvh" p="md">
            <Paper withBorder p="xl" maw={380} w="100%">
                <Stack align="center" gap="md">
                    <Image src={logo} w={88} h={88} radius="lg" alt="FastFresh" />
                    <Title order={2} ta="center">
                        Вход в админку
                    </Title>
                    <Text c="dimmed" ta="center" size="sm">
                        Авторизация через Telegram. Доступ есть у ролей ADMIN и MANAGER.
                    </Text>
                    <Button component="a" href={loginUrl()} size="md" fullWidth leftSection={<Send size={18} />} color="#0088cc">
                        Войти через Telegram
                    </Button>
                </Stack>
            </Paper>
        </Center>
    );
}

export function ForbiddenScreen() {
    return (
        <Center mih="100dvh" p="md">
            <Paper withBorder p="xl" maw={380} w="100%">
                <Stack align="center" gap="md">
                    <Title order={3} c="red">
                        Нет доступа
                    </Title>
                    <Text c="dimmed" ta="center" size="sm">
                        Ваша роль не даёт доступа к админке. Попросите администратора выдать роль ADMIN или MANAGER.
                    </Text>
                    <Button variant="default" onClick={clearToken}>
                        Выйти
                    </Button>
                </Stack>
            </Paper>
        </Center>
    );
}
